module.exports = __webpack_public_path__ + "static/media/photoshop-logo-mobile.893f9d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/photoshop-logo-mobile.png
// module id = 70
// module chunks = 0